module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-290.c009e20.woff2";